import React, { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

const GlobalContext = createContext();
export const useGlobal = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
  const [sharedValue, setSharedValue] = useState(() => {
    const saved = localStorage.getItem("globalState");
    const parsed = saved ? JSON.parse(saved) : {};

    return {
      appName: "",
      packageName: "",
      reqError: "",
      apkData: {},
      searchedApp: "",
      cookiesAccepted: false,
      showNoResult: false,
      // Datos usuario
      nombre: "",
      username: "Anónimo",
      email: "",
      rol: "",
      telefono: "",
      fotoPerfil: "",
      biografia: "",
      id: "",
      ...parsed
    };
  });

  useEffect(() => {
    const { reqError, ...stateToPersist } = sharedValue;
    localStorage.setItem("globalState", JSON.stringify(stateToPersist));
  }, [sharedValue]);

  // Para modificar un solo campo
  const updateSharedValue = (key, newValue) => {
    setSharedValue(prev => ({ ...prev, [key]: newValue }));
  };

  // Para modificar varios a la vez
  const updateSharedValues = updates => {
    setSharedValue(prev => ({
      ...prev,
      ...updates,
    }));
  };

  const USER_DEFAULTS = {
    nombre: "",
    username: "Anónimo",
    email: "",
    institution: "",
    rol: "",
    telefono: "",
    fotoPerfil: "",
    biografia: "",
    id: "",
  };

  const clearUserData = () => {
    setSharedValue(prev => ({
      ...prev,
      ...USER_DEFAULTS,
      appName: "",
      packageName: "",
      apkData: {},
      showNoResult: false,
    }));
  };

  const clearSearchData = () => {
    setSharedValue(prev => ({
      ...prev,
      appName: "",
      packageName: "",
      searchedApp: "",
      showNoResult: false,
    }));
  };

  return (
    <GlobalContext.Provider
      value={{
        sharedValue,
        updateSharedValue,
        clearUserData,
        updateSharedValues,
        clearSearchData,
      }}
    >
    {children}
  </GlobalContext.Provider>
  );
};

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};